import styled from "styled-components";

export const BreadcrumbLinkStyled  = styled.a`
  color: rgba(31, 10, 53, 0.5);
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;
`;